import { render, staticRenderFns } from "./PermissionAssignment.vue?vue&type=template&id=9e3b8dbc&scoped=true&"
import script from "./PermissionAssignment.vue?vue&type=script&lang=js&"
export * from "./PermissionAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3b8dbc",
  null
  
)

export default component.exports